<template>
    <div>
        {{ getValue }}
    </div>
</template>

<script>

import Vue from "vue";

export default
{
    components: {},
    props: {
        column: {
            type: Object,
        },
        row: {
            type: Object,
        },
    },
    data() {
        return {

        };
    },
    computed: {
        getValue() {
            let value = this.row[this.column.data];

            if (true === value) {
                return Vue.prototype.$translate.text('Yes');
            }

            return Vue.prototype.$translate.text('No');
        },
    },
    mounted() {
    },
    methods: {
    },
}
</script>

<style lang="sass">
</style>


// WEBPACK FOOTER //
// BooleanColumnComponent.vue?39dfcf80